<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <h4>Reporte de Pacientes por Edad</h4>
    </div>
    <hr>
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button
        v-for="atajo in atajos" :key="atajo.key"
        class="btn btn-sm" :class="atajo.clase"
        @click="aplicarAtajo(atajo)"
      >{{ atajo.label }}</button>
    </div>
    <div class="input-group mb-3">
      <span class="input-group-text">Desde</span>
      <input type="date" v-model="fechaDesde" class="form-control">
      <span class="input-group-text">Hasta</span>
      <input type="date" v-model="fechaHasta" class="form-control">
      <button
        class="btn btn-dark"
        @click="generarReporte"
        :disabled="!fechaDesde || !fechaHasta || cargando"
      >
        <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
        Consultar
      </button>
      <button
        class="btn btn-success"
        @click="exportToCSV"
        :disabled="!gruposEtareos.length"
      >
        <span class="material-symbols-outlined align-middle" style="font-size:16px">download</span>
        CSV
      </button>
    </div>

    <div v-if="gruposEtareos.length">
      <!-- KPIs -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total atenciones</div>
            <div class="kpi-value">{{ totalAtenciones.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total pacientes</div>
            <div class="kpi-value">{{ totalPacientes.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Grupo etario líder</div>
            <div class="kpi-value kpi-value--sm">{{ grupoTop }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Grupos activos</div>
            <div class="kpi-value">{{ gruposEtareos.length }}</div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tabs">
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'tabla' }" @click="vistaActiva = 'tabla'">
          <span class="material-symbols-outlined" style="font-size:17px">table_view</span>
          Tabla
        </button>
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'atenciones' }" @click="vistaActiva = 'atenciones'">
          <span class="material-symbols-outlined" style="font-size:17px">bar_chart</span>
          N° Atenciones
        </button>
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'pacientes' }" @click="vistaActiva = 'pacientes'">
          <span class="material-symbols-outlined" style="font-size:17px">group</span>
          N° Pacientes
        </button>
      </div>

      <!-- ── TABLA ── -->
      <div v-if="vistaActiva === 'tabla'" class="mt-3">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
          <div class="input-group input-group-sm" style="max-width:300px">
            <span class="input-group-text">
              <span class="material-symbols-outlined" style="font-size:15px">search</span>
            </span>
            <input
              type="text" class="form-control"
              placeholder="Buscar grupo etario…"
              v-model="busqueda"
              @input="paginaActual = 1"
            >
            <button v-if="busqueda" class="btn btn-outline-secondary" @click="busqueda = ''; paginaActual = 1">
              <span class="material-symbols-outlined" style="font-size:15px">close</span>
            </button>
          </div>
          <div class="d-flex align-items-center gap-2">
            <small class="text-muted">Mostrar</small>
            <select class="form-select form-select-sm" style="width:75px" v-model="filasPorPagina" @change="paginaActual = 1">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
            <small class="text-muted">filas</small>
          </div>
        </div>

        <table class="table table-bordered table-hover table-sm">
          <thead class="table-dark">
            <tr>
              <th class="sortable" @click="ordenar('label')">
                Grupo etario
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'label' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end sortable" @click="ordenar('atenciones')">
                Atenciones
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'atenciones' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Atenciones</th>
              <th class="text-end sortable" @click="ordenar('pacientes')">
                Pacientes
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'pacientes' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Pacientes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filasPagina.length">
              <td colspan="5" class="text-center text-muted py-3">Sin resultados para "{{ busqueda }}"</td>
            </tr>
            <tr v-for="(g, index) in filasPagina" :key="index">
              <td>{{ g.label }}</td>
              <td class="text-end">{{ g.atenciones }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar pct-bar--blue" :style="{ width: porcentaje(g.atenciones, totalAtenciones) + '%' }"></div>
                  </div>
                  {{ porcentaje(g.atenciones, totalAtenciones) }}%
                </div>
              </td>
              <td class="text-end">{{ g.pacientes }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar pct-bar--teal" :style="{ width: porcentaje(g.pacientes, totalPacientes) + '%' }"></div>
                  </div>
                  {{ porcentaje(g.pacientes, totalPacientes) }}%
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td>Total ({{ filasFiltradas.length }} grupos{{ busqueda ? ' filtrados' : '' }})</td>
              <td class="text-end">{{ totalAtenciones }}</td>
              <td class="text-end">100%</td>
              <td class="text-end">{{ totalPacientes }}</td>
              <td class="text-end">100%</td>
            </tr>
          </tfoot>
        </table>

        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Mostrando {{ rangoDesde }}–{{ rangoHasta }} de {{ filasFiltradas.length }} registros
          </small>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                <button class="page-link" @click="paginaActual--">‹</button>
              </li>
              <li
                v-for="p in paginasVisibles" :key="p"
                class="page-item"
                :class="{ active: p === paginaActual, disabled: p === '…' }"
              >
                <button class="page-link" @click="p !== '…' && (paginaActual = p)">{{ p }}</button>
              </li>
              <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
                <button class="page-link" @click="paginaActual++">›</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!-- ── GRÁFICO ATENCIONES ── -->
      <div v-if="vistaActiva === 'atenciones'" class="mt-3">
        <apexchart
          type="bar"
          :options="chartAtenciones"
          :series="seriesAtenciones"
          height="420"
        />
      </div>

      <!-- ── GRÁFICO PACIENTES ── -->
      <div v-if="vistaActiva === 'pacientes'" class="mt-3">
        <apexchart
          type="bar"
          :options="chartPacientes"
          :series="seriesPacientes"
          height="420"
        />
      </div>
    </div>

    <div v-else-if="consultado" class="alert alert-info mt-3">
      No hay datos para el período seleccionado.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import VueApexCharts from 'vue3-apexcharts'
import api           from '@/services/api'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

const GRUPOS = [
  { label: '0-4 años',   min: 0,  max: 4          },
  { label: '5-9 años',   min: 5,  max: 9          },
  { label: '10-14 años', min: 10, max: 14         },
  { label: '15-19 años', min: 15, max: 19         },
  { label: '20-24 años', min: 20, max: 24         },
  { label: '25-29 años', min: 25, max: 29         },
  { label: '30-34 años', min: 30, max: 34         },
  { label: '35-39 años', min: 35, max: 39         },
  { label: '40-44 años', min: 40, max: 44         },
  { label: '45-49 años', min: 45, max: 49         },
  { label: '50-54 años', min: 50, max: 54         },
  { label: '55-59 años', min: 55, max: 59         },
  { label: '60-64 años', min: 60, max: 64         },
  { label: '65-69 años', min: 65, max: 69         },
  { label: '70-74 años', min: 70, max: 74         },
  { label: '75-79 años', min: 75, max: 79         },
  { label: '80+ años',   min: 80, max: Infinity   },
]

function agrupar(filas) {
  return GRUPOS.map(g => {
    const subset = filas.filter(f => f[0] >= g.min && f[0] <= g.max)
    return {
      label:      g.label,
      atenciones: subset.reduce((s, f) => s + f[1], 0),
      pacientes:  subset.reduce((s, f) => s + f[2], 0),
    }
  }).filter(g => g.atenciones > 0 || g.pacientes > 0)
}

function baseChart(titulo, color, labels) {
  return {
    chart:       { toolbar: { show: false }, fontFamily: 'inherit' },
    plotOptions: { bar: { borderRadius: 4, columnWidth: '60%' } },
    colors:      [color],
    dataLabels:  { enabled: false },
    xaxis: {
      categories: labels,
      title:  { text: 'Grupo etario', style: { fontWeight: 600 } },
      labels: { rotate: -40, style: { fontSize: '12px' } },
    },
    yaxis:   { title: { text: titulo, style: { fontWeight: 600 } } },
    tooltip: { y: { formatter: v => v.toLocaleString() } },
    grid:    { borderColor: '#e9ecef' },
  }
}

export default {
  name: 'ReportePacientesPorEdad',
  components: { Layout, Footer, apexchart: VueApexCharts },
  data() {
    return {
      fechaDesde:       '',
      fechaHasta:       '',
      pacientesPorEdad: [],
      gruposEtareos:    [],
      vistaActiva:      'tabla',
      cargando:         false,
      consultado:       false,
      // tabla
      busqueda:       '',
      filasPorPagina: 25,
      paginaActual:   1,
      sortKey:        'atenciones',
      sortDir:        'desc',
      atajos: [
        { key: 'hoy',       label: 'Hoy',             clase: 'btn-outline-primary',   fn: getToday        },
        { key: 'semana',    label: 'Semana actual',    clase: 'btn-outline-danger',    fn: getThisWeek     },
        { key: 'mes',       label: 'Mes actual',       clase: 'btn-outline-secondary', fn: getThisMonth    },
        { key: 'trimestre', label: 'Trimestre actual', clase: 'btn-outline-success',   fn: getThisQuarter  },
        { key: 'semestre',  label: 'Semestre actual',  clase: 'btn-outline-info',      fn: getThisSemester },
        { key: 'anio',      label: 'Año actual',       clase: 'btn-outline-warning',   fn: getThisYear     },
      ],
    }
  },
  computed: {
    totalAtenciones() {
      return this.gruposEtareos.reduce((s, g) => s + g.atenciones, 0)
    },
    totalPacientes() {
      return this.gruposEtareos.reduce((s, g) => s + g.pacientes, 0)
    },
    grupoTop() {
      if (!this.gruposEtareos.length) return '—'
      return [...this.gruposEtareos].sort((a, b) => b.atenciones - a.atenciones)[0].label
    },
    // ── Tabla ──
    filasFiltradas() {
      const q = this.busqueda.toLowerCase().trim()
      const base = q
        ? this.gruposEtareos.filter(g => g.label.toLowerCase().includes(q))
        : [...this.gruposEtareos]
      base.sort((a, b) => {
        const av = a[this.sortKey] ?? a.label
        const bv = b[this.sortKey] ?? b.label
        if (av < bv) return this.sortDir === 'asc' ? -1 : 1
        if (av > bv) return this.sortDir === 'asc' ? 1 : -1
        return 0
      })
      return base
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.filasFiltradas.length / this.filasPorPagina))
    },
    rangoDesde() {
      return this.filasFiltradas.length ? (this.paginaActual - 1) * this.filasPorPagina + 1 : 0
    },
    rangoHasta() {
      return Math.min(this.paginaActual * this.filasPorPagina, this.filasFiltradas.length)
    },
    filasPagina() {
      return this.filasFiltradas.slice(this.rangoDesde - 1, this.rangoHasta)
    },
    paginasVisibles() {
      const total = this.totalPaginas
      const cur   = this.paginaActual
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
      const pages = [1]
      if (cur > 3) pages.push('…')
      for (let p = Math.max(2, cur - 1); p <= Math.min(total - 1, cur + 1); p++) pages.push(p)
      if (cur < total - 2) pages.push('…')
      pages.push(total)
      return pages
    },
    // ── Gráficos ──
    labels() {
      return this.gruposEtareos.map(g => g.label)
    },
    chartAtenciones() {
      return baseChart('Número de atenciones', '#0d6efd', this.labels)
    },
    chartPacientes() {
      return baseChart('Número de pacientes', '#20c997', this.labels)
    },
    seriesAtenciones() {
      return [{ name: 'Atenciones', data: this.gruposEtareos.map(g => g.atenciones) }]
    },
    seriesPacientes() {
      return [{ name: 'Pacientes', data: this.gruposEtareos.map(g => g.pacientes) }]
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    aplicarAtajo(atajo) {
      const { fechaDesde, fechaHasta } = atajo.fn()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.generarReporte()
    },
async generarReporte() {
  if (!this.fechaDesde || !this.fechaHasta) return
  this.cargando     = true
  this.consultado   = false
  this.busqueda     = ''
  this.paginaActual = 1
  try {
    const idEmpresa = window.sessionStorage.getItem('idEmpresa')
    const { data }  = await api.get('/vwatencions/por-fecha', {
      params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
    })

    const atenciones = data ?? []

    // Agrupar por idPersona dentro de cada grupo etario para contar pacientes únicos
    const mapa = {}  // { label -> { atenciones: N, pacientes: Set<idPersona> } }

    for (const ate of atenciones) {
      const edad = parseInt(ate.edadAteYears ?? ate.edadNacYears ?? 0)
      const grupo = GRUPOS.find(g => edad >= g.min && edad <= g.max)
      if (!grupo) continue

      if (!mapa[grupo.label]) {
        mapa[grupo.label] = { atenciones: 0, pacientes: new Set() }
      }
      mapa[grupo.label].atenciones++
      if (ate.idPersona) {
        mapa[grupo.label].pacientes.add(ate.idPersona)
      }
    }

    // Convertir al formato [edad, atenciones, pacientes] que espera agrupar()
    // Usamos el min del grupo como valor numérico de edad representativo
    this.pacientesPorEdad = GRUPOS
      .filter(g => mapa[g.label])
      .map(g => [
        g.min,                            // [0] edad numérica → para que agrupar() lo filtre correctamente
        mapa[g.label].atenciones,         // [1] total atenciones
        mapa[g.label].pacientes.size,     // [2] pacientes únicos
      ])

    this.gruposEtareos = agrupar(this.pacientesPorEdad)

  } catch (error) {
    console.error('Error al obtener los datos:', error)
    this.pacientesPorEdad = []
    this.gruposEtareos    = []
  } finally {
    this.cargando   = false
    this.consultado = true
  }
},
    ordenar(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortDir = key === 'label' ? 'asc' : 'desc'
      }
      this.paginaActual = 1
    },
    porcentaje(valor, total) {
      if (!total) return 0
      return ((valor / total) * 100).toFixed(1)
    },
    exportToCSV() {
      const filas = [
        ['Grupo etario', 'Atenciones', '% Atenciones', 'Pacientes', '% Pacientes'],
        ...this.gruposEtareos.map(g => [
          g.label,
          g.atenciones,
          `${this.porcentaje(g.atenciones, this.totalAtenciones)}%`,
          g.pacientes,
          `${this.porcentaje(g.pacientes, this.totalPacientes)}%`,
        ]),
        ['Total', this.totalAtenciones, '100%', this.totalPacientes, '100%'],
      ]
      const csv  = filas.map(f => f.join(',')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url  = URL.createObjectURL(blob)
      const a    = Object.assign(document.createElement('a'), {
        href: url, download: 'Reporte_Pacientes_Por_Edad.csv',
      })
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
/* ── KPIs ── */
.kpi-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 14px 18px;
  text-align: center;
}
.kpi-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: .04em;
  margin-bottom: 4px;
}
.kpi-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0d6efd;
  line-height: 1.1;
}
.kpi-value--sm {
  font-size: 0.95rem;
  font-weight: 600;
}
/* ── Tabs ── */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
}
.tablink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
}
.tablink:hover  { color: #0d6efd; background: #f0f4ff; }
.active-tab     { color: #0d6efd; border-bottom-color: #0d6efd; background: #fff; font-weight: 600; }
/* ── Tabla ── */
.sortable { cursor: pointer; user-select: none; white-space: nowrap; }
.sortable:hover { background: #495057; }
.sort-icon { font-size: 14px; vertical-align: middle; opacity: .7; }
/* Barras de porcentaje duales */
.pct-bar-wrap {
  width: 60px;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}
.pct-bar {
  height: 100%;
  border-radius: 3px;
  transition: width 0.4s ease;
}
.pct-bar--blue { background: #0d6efd; }
.pct-bar--teal { background: #20c997; }
</style>